var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore, createContainer } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { update } from "framework/state/loader";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { EntityValidator, FieldValidator } from "framework/validation/validator";
import { setEntityField } from "framework/state/entity";
import { apiCreateEventOfficial, apiUpdateEventOfficial } from "../../../endpoint";
import { EventOfficialDefaults } from "../../../entity";
var NewOfficialPhase;
(function (NewOfficialPhase) {
    NewOfficialPhase[NewOfficialPhase["None"] = 0] = "None";
    NewOfficialPhase[NewOfficialPhase["Submiting"] = 1] = "Submiting";
    NewOfficialPhase[NewOfficialPhase["Submitted"] = 2] = "Submitted";
})(NewOfficialPhase || (NewOfficialPhase = {}));
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: __assign({}, EventOfficialDefaults), errors: __assign({}, NoEntityError), availableOfficialRoles: [], selectedOfficial: null, lastSavedEntity: __assign({}, EventOfficialDefaults), newOfficialPhase: NewOfficialPhase.None });
var validate = function (store, requireExisting) {
    var entity = store.getState().entity;
    var validator = EntityValidator();
    validator.storeFieldResult("role", FieldValidator()
        .validateNotEmpty(entity.role)
        .validateIntGZ(entity.role)
        .getResult());
    validator.storeFieldResult("idt", FieldValidator()
        .validateNotEmpty(entity.idt)
        .getResult());
    store.setState(function (draft) {
        draft.errors = validator.getResult();
    });
    return validator.isValid();
};
var hasChanges = function (draft) {
    return JSON.stringify(draft.entity) != JSON.stringify(draft.lastSavedEntity);
};
var saveOfficial = function (forcedSave) { return function (store) {
    if (!validate(store, false)) {
        return;
    }
    if (!forcedSave && !hasChanges(store.getState())) {
        return;
    }
    store.setState(function (draft) {
        draft.newOfficialPhase = NewOfficialPhase.Submiting;
    });
    var entity = store.getState().entity;
    var isExisting = entity.id != null && entity.id !== 0;
    var updater = function () { return isExisting ? apiUpdateEventOfficial(entity.eventId, entity) : apiCreateEventOfficial(entity.eventId, entity); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByEntityResponse(draft, response);
            if (response.succeeded) {
                draft.lastSavedEntity = draft.entity;
                draft.newOfficialPhase = NewOfficialPhase.Submitted;
            }
            else {
                draft.newOfficialPhase = NewOfficialPhase.None;
            }
        });
    };
    update(store, updater, stateProducer);
}; };
var setAvailableOfficialRoles = function (availableRoles) { return function (store) {
    store.setState(function (draft) {
        draft.availableOfficialRoles = availableRoles;
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        saveOfficial: saveOfficial,
        setAvailableOfficialRoles: setAvailableOfficialRoles,
        setEntityField: setEntityField,
    },
    name: "EventsPlanningOfficialsItemEdit"
});
var useState = createHook(store);
var Container = createContainer(store, {
    onInit: function () { return function (_a, _b) {
        var setState = _a.setState;
        var official = _b.official;
        setState(function (draft) {
            draft.entity = official;
            draft.lastSavedEntity = official;
        });
    }; },
});
export { NewOfficialPhase, Container as EventsPlanningOfficialsItemEditContainer, StateDefaults as EventsPlanningOfficialsItemEditDefaults, useState as useEventsPlanningOfficialsItemEdit, };
